var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px / chat, support",
    clipPath: "url(#clip0_8427_13835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7992 4.54688V6.56793C12.7992 7.63996 12.3946 8.66809 11.6744 9.42613C10.9543 10.1842 9.97758 10.61 8.95915 10.61H7.83403L6.13867 12.3956C6.40747 12.5462 6.71371 12.6311 7.03915 12.6311H8.95915L11.8392 15.6627V12.6311H13.7592C14.2684 12.6311 14.7567 12.4182 15.1168 12.0391C15.4769 11.6601 15.6792 11.146 15.6792 10.61V6.56793C15.6792 6.03191 15.4769 5.51785 15.1168 5.13883C14.7567 4.75981 14.2684 4.54688 13.7592 4.54688H12.7992Z",
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.320312 2.5274C0.320312 1.99138 0.522598 1.47732 0.882667 1.0983C1.24274 0.719279 1.7311 0.506348 2.24031 0.506348H8.96031C9.46953 0.506348 9.95789 0.719279 10.318 1.0983C10.678 1.47732 10.8803 1.99138 10.8803 2.5274V6.5695C10.8803 7.10552 10.678 7.61958 10.318 7.9986C9.95789 8.37762 9.46953 8.59056 8.96031 8.59056H7.04031L4.16031 11.6221V8.59056H2.24031C1.7311 8.59056 1.24274 8.37762 0.882667 7.9986C0.522598 7.61958 0.320313 7.10552 0.320312 6.5695V2.5274Z",
    fill: "#052B5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8427_13835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSupport);
export default __webpack_public_path__ + "static/media/chatSupport.d00cd859518f3a85f230d1e5e4084662.svg";
export { ForwardRef as ReactComponent };